import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Pages (to be created/converted)
import IndexPage from './pages/IndexPage';
import SSOInitPage from './pages/SSOInitPage';
import RestaurantPage from './pages/RestaurantPage';
import BookingPage from './pages/BookingPage';
import PluginNotFoundPage from './pages/PluginNotFoundPage';

function App() {
  return (
    <div className="min-h-screen bg-secondary-50">
      <Routes>
        <Route path="/" element={<IndexPage />} />
        <Route path="/sso-init" element={<SSOInitPage />} />
        <Route path="/restaurant" element={<RestaurantPage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/plugin-not-found" element={<PluginNotFoundPage />} />
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
